export const WAREHOUSE_BRANCH_IDS = ["550", "590"]
export const WM_BRANCH_IDS = ["210", "220", "230", "240", "250", "260"]

/** Branch IDs for which checkout actions are disabled - EINZA-2377 */
export const CHECKOUT_DISABLED_BRANCH_IDS = [...WAREHOUSE_BRANCH_IDS, ...WM_BRANCH_IDS]

/** Branch IDs excluded from the internal customers import */
export const INTERNAL_CUSTOMER_EXCLUDED_BRANCH_IDS = [...WAREHOUSE_BRANCH_IDS, ...WM_BRANCH_IDS, "600"]
